import type { Chat } from '@/types/chat';
import { getChatGroupLabel } from '@/interfaces/utils/dateLabel';

export function groupChatByLabel(chats: Chat[]): Record<string, Chat[]> {
  const groups: Record<string, Chat[]> = {};

  chats.forEach((chat) => {
    const label = getChatGroupLabel(chat.last_message_at);
    if (!groups[label]) groups[label] = [];
    groups[label].push(chat);
  });

  return groups;
}
